import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";

// Shows images that came from the live web-search results (accurate + source-tied).
// External URLs: lazy-loaded, no-referrer, and any that fail to load are hidden.
export function SourceImages({ images }) {
  const { language } = useLanguage();
  const [broken, setBroken] = useState({});
  if (!images || images.length === 0) return null;
  const anyVisible = images.some((_, i) => !broken[i]);
  if (!anyVisible) return null;
  return (
    <div className="mt-3" data-testid="source-images">
      <p className="mb-1.5 text-xs font-medium text-slate-400">{language === "hi" ? "वेब से तस्वीरें" : "From the web"}</p>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {images.map((im, i) =>
          broken[i] ? null : (
            <a key={i} href={im.url} target="_blank" rel="noopener noreferrer" title={im.description || ""} className="block flex-shrink-0">
              <img
                src={im.url}
                alt={im.description || "Related image from the web"}
                referrerPolicy="no-referrer"
                loading="lazy"
                onError={() => setBroken((p) => ({ ...p, [i]: true }))}
                data-testid={`source-image-${i}`}
                className="h-28 w-40 rounded-xl border border-slate-200 object-cover"
              />
            </a>
          )
        )}
      </div>
    </div>
  );
}
